import src from "IMAGE";
export default { src, width: 1055, height: 245, blurWidth: 0, blurHeight: 0};
